import React from 'react'
import {connect} from 'react-redux'
import {createStructuredSelector} from 'reselect'
import classNames from 'classnames'
import {useHistory} from 'react-router-dom'
import type {Product as DisplayedProduct} from '../../../contexts/types'

import * as cross from '../../../store/cross'
import * as user from '../../../store/user'
import * as productSelectors from '../../../store/product'
import * as track from '../../../track/track'
import {CartContext} from '../../../contexts/CartContext'
import {CART_ADD_ITEM} from '../../../urls'

type Product = {
  displayedProduct: DisplayedProduct
}

type AddItemButton = {
  isAuthenticated: boolean
  selectedTransactionType: string
  product: Product
}
const AddItemButton: React.FC<AddItemButton> = ({
  isAuthenticated,
  selectedTransactionType,
  product,
}) => {
  const history = useHistory()
  const {addToCart} = React.useContext(CartContext)

  const handleAddToCart = async () => {
    await addToCart(product.displayedProduct)

    track.viewedCart(CART_ADD_ITEM)
    history.push(CART_ADD_ITEM)
  }

  const addButton = (
    <button
      type="button"
      className="pdp-atl-button"
      onClick={handleAddToCart}
      disabled={!selectedTransactionType}
      data-test-id="add-product-to-cart-button"
    >
      <span className="pdp-atl-button-text">Add to Order</span>
    </button>
  )

  return (
    <div
      className={classNames('pdp-atl', {
        'is--authenticated': isAuthenticated,
      })}
    >
      {addButton}
    </div>
  )
}
const mapStateToProps = createStructuredSelector({
  isAuthenticated: user.isAuthenticated,
  selectedTransactionType: cross.selectedTransactionType,
  product: productSelectors.product,
})

export default connect(mapStateToProps)(AddItemButton)
